<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs settings-amenities">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="settingsAmenitiesService.showDetailedView"
         [ngStyle]="{width: settingsAmenitiesService.showDetailedView ? 'calc(100% - 520px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Amenity'" [buildings]="settingsAmenitiesService.buildingsForRead"></filter>
                </div>

                <settings-amenities-filter></settings-amenities-filter>

                <div *ngIf="settingsAmenitiesService.canEdit()" class="col-sm-3">
                    <button type="button"
                            class="btn btn-w-m btn-primary pull-right"
                            (click)="settingsAmenitiesService.isSettingsAmenitiesModalShow = true">
                        <i class="fa fa-plus-circle"></i> New Amenity
                    </button>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12">
                    <filters-view></filters-view>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allSettingsAmenities'" [ngClass]="{'sk-loading': settingsAmenitiesService.spinnerShow}">
                    <settings-amenities-list></settings-amenities-list>
                    <spinner [spinnerShow]="settingsAmenitiesService.spinnerShow"></spinner>
                </tab-item>
                <pagination *ngIf="settingsAmenitiesService.data.allSettingsAmenities.total && urlService.queryParams['page']"
                            [total]="settingsAmenitiesService.data['allSettingsAmenities'].total">
                </pagination>
            </tabs-wrapper>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar">
        <settings-amenities-detailed-view></settings-amenities-detailed-view>
    </div>
</div>

<settings-amenities-modal *ngIf="settingsAmenitiesService.isSettingsAmenitiesModalShow"></settings-amenities-modal>
<schedule-modal *ngIf="settingsAmenitiesService.isScheduleModalShow"></schedule-modal>
<legal-agreement-modal *ngIf="settingsAmenitiesService.isLegalAgreementModalShow"></legal-agreement-modal>
<disabled-dates-modal *ngIf="settingsAmenitiesService.isDisabledDatesModalShow"></disabled-dates-modal>
<booking-request-modal *ngIf="settingsAmenitiesService.isBookingRequestModalShow"></booking-request-modal>
<disclaimer-modal *ngIf="settingsAmenitiesService.isDisclaimerModalShow"></disclaimer-modal>
<payment-modal *ngIf="settingsAmenitiesService.isPaymentModalShow"></payment-modal>
<reminders-modal *ngIf="settingsAmenitiesService.isRemindersModalShow"></reminders-modal>



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/settings-amenities.component.html